import {eventListenerService} from '@/modules/common/services'
import {urlUtil} from '@/modules/common/utils'
const iframeId = urlUtil.getParameterByName("iframeId")
const activeListeners = {}

window.addEventListener("message", function (e) {
  if (typeof e.data  !== 'string' && e.data.source === 'frontage-message') {
    eventListenerService.emit('on-frontage-message', e.data.message)
  }
});

const postAndListen = (params, callback) => {
  // prevent adding multiple listeners for the same message
  if (!activeListeners[params.message]) {
    window.addEventListener("message", function (e) {
      if(typeof e.data  == 'string') {
        const resp = e.data ? JSON.parse(e.data) : ''
        if(resp.target == 'message_to_vue_app') {
          callback(resp)
        }
      }else{
        callback(e)
      }
    });
    activeListeners[params.message] = true
  }

  let payload = {event: params.message, origin: iframeId}
  if (params.data){
    payload.data = params.data
  }

  window.parent.postMessage(payload, "*");
}

const post = (message, data) => {

  let payload = {event: message, origin: iframeId}
  if (data){
    payload.data = data
  }
  window.parent.postMessage(payload, "*")
}


const openWindow = (url, options = {}) => {
  const data = {...options, url}
  post('open_window', data)
}

export default {
    post,
    postAndListen,
    openWindow
};
